import { useState, useRef } from 'react';
import phone from '../assets/img/phone.png';
import { motion } from 'framer-motion';
import appVideo from '../assets/video/Obsessless_App_Video.mp4';


export const AppPresentationVideo = () => {
    const [isVideoReady, setIsVideoReady] = useState(false);
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleCanPlay = () => {
        setIsVideoReady(true);
    };

    const handleLoadedData = () => {
        setIsVideoLoaded(true);
    };

    const handleVideoError = () => {
        // If video fails to load, we still want to show the phone frame
        setIsVideoReady(true);
        setIsVideoLoaded(true);
    };

    return (
        <motion.div
            className="relative w-[300px] h-[611px]"
            initial={{
                opacity: 0,
                x: 40,
                y: 120,
                rotate: 6
            }}
            animate={{
                opacity: isVideoReady ? [0, 0, 0.5, 1] : 0,
                x: isVideoReady ? 0 : 40,
                y: isVideoReady ? 0 : 120,
                rotate: isVideoReady ? 0 : 6
            }}
            transition={{ duration: 0.7, times: [0, 0.5, 0.7, 1] }}
        >
            <motion.video
                ref={videoRef}
                src={appVideo}
                autoPlay
                muted
                loop
                playsInline
                className="absolute top-[13px] left-1/2 -translate-x-1/2 h-[96%] object-cover rounded-[42px] z-[-1]"
                onCanPlay={handleCanPlay}
                onLoadedData={handleLoadedData}
                onError={handleVideoError}
                initial={{ opacity: 0 }}
                animate={{ opacity: isVideoLoaded ? 1 : 0 }}
                transition={{ duration: 0.3 }}
            />
            <img src={phone} alt="phone" className='w-full h-full object-contain' />

            {/* Loading indicator - only show if video is not ready */}
            {!isVideoReady && (
                <motion.div
                    className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded-[42px]"
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
                </motion.div>
            )}
        </motion.div>
    );
};
